import { gql, type TypedDocumentNode } from '@apollo/client';
import { type IDurationConstantResponse } from './interfaces';

export const DURATION_CONSTANTS_QUERY: TypedDocumentNode<IDurationConstantResponse, {  }> = gql`
    query DURATION_CONSTANTS_QUERY {
        appointmentDurations {
            title
            value
        }
    }
`